import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from '../ui/accordion';

const FAQS = [
  {
    id: 'per-user',
    question: 'How does per-user pricing work?',
    answer: "Per-user pricing means you pay a monthly fee for each employee who uses your IT systems. This typically includes their computer, email, and access to help desk support. It's predictable and scales with your team.",
  },
  {
    id: 'commitment',
    question: "What's the minimum commitment?",
    answer: "We offer month-to-month agreements with no long-term contracts required. However, most clients choose annual agreements for a 10% discount. We're confident you'll want to stay once you experience our service.",
  },
  {
    id: 'hidden-fees',
    question: 'Are there any hidden fees?',
    answer: 'No. Your monthly fee covers everything listed in your plan. The only additional charges would be for optional add-ons you explicitly request, or out-of-scope projects like major migrations or new hardware purchases.',
  },
  {
    id: 'users-vs-devices',
    question: 'What if we have more users than devices (or vice versa)?',
    answer: "We price primarily per user, which typically includes one primary device. If you have users with multiple devices or shared workstations, we'll create a custom quote that makes sense for your situation.",
  },
  {
    id: 'discounts',
    question: 'Do you offer discounts for nonprofits or startups?',
    answer: 'Yes! We offer 15% off for registered nonprofits and special startup pricing for companies under 2 years old. Contact us to discuss your situation.',
  },
  {
    id: 'scaling',
    question: 'What happens if we need to scale up or down?',
    answer: "Adding users is easy — just let us know and we'll provision them within 24 hours. If you need to reduce users, changes take effect at the next billing cycle with 30 days notice.",
  },
];

export function FaqSection() {
  return (
    <section className="py-20 bg-slate-50" data-testid="pricing-faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-black text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Pricing FAQ
          </h2>
          <p className="text-lg text-slate-600">Common questions about our pricing and plans.</p>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={faq.id}
              className="bg-white border border-slate-200 rounded-lg px-6"
              data-testid={`faq-${faq.id}`}
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
